import { styled } from '@material-ui/core';

export const Footer = styled('footer')({
  display: 'flex',
  justifyContent: 'flex-end',
  '& > button': {
    marginLeft: 8,
  },
});
